import { render, staticRenderFns } from "./ui-menu.vue?vue&type=template&id=f31d089a&scoped=true&"
import script from "./ui-menu.vue?vue&type=script&lang=ts&"
export * from "./ui-menu.vue?vue&type=script&lang=ts&"
import style0 from "./ui-menu.vue?vue&type=style&index=0&id=f31d089a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31d089a",
  null
  
)

export default component.exports